<div class="flex flex-col items-center mt-4 relative"
     *transloco="let t; read 'prices.upsert_price';">
  <a [routerLink]="this.backRoute"
     class="text-blue2 absolute left-8 top-5 border-2 rounded-full border-blue2 h-[40px] w-[40px] hover:bg-yellow2 transform transition cursor-pointer flex justify-center items-center">
    <mat-icon class="font-bold">arrow_back</mat-icon>
  </a>
  <psc-section-title
    [title]="t('title')"></psc-section-title>
  <form
    class="w-[95%] md:w-2/3 xl:w-1/2"
    [formGroup]="formGroup">

    <ng-container *transloco="let g; read 'prices';">
      <psc-input
        formControlName="name"
        [readonly]="!userIsAdmin"
        [label]="g('name')"></psc-input>
      <psc-input
        formControlName="tariffModel"
        [label]="g('tariff_model')"></psc-input>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-x-4 items-center mb-4">
        <psc-select
          [options]="countriesOptions"
          formControlName="country"
          [label]="g('country')"></psc-select>
        <!-- t(prices.upsert_price.HOME, prices.upsert_price.ENTERPRISE) -->
        <psc-select
          [options]="typeOptions | translateLabels:t"
          formControlName="type"
          [label]="g('price_type')"></psc-select>
        <!-- t(prices.upsert_price.PUBLIC_ADVANCE, prices.upsert_price.PUBLIC_BASIC) -->
        <psc-select
          *pscRoleAccess="[UserRole.ROLE_ADMIN]"
          [options]="privacyStatusOptions | translateLabels:t"
          formControlName="privacyStatus"
          [label]="g('privacy_status')"></psc-select>
        <psc-input
          type="number"
          formControlName="tax"
          prefix="%"
          [label]="g('tax')"></psc-input>
        <div class="flex items-center justify-around ml-4 min-h-[58px]">
          <div class="flex items-center gap-2">
            {{ g('saturday') }}:
            <psc-switch
              formControlName="saturday"
              [checkedLabel]="g('true')"
              [uncheckedLabel]="g('false')"></psc-switch>
          </div>
          <div class="h-[15px] border border-gray-300"></div>
          <div class="flex items-center gap-2">
            {{ g('sunday') }}:
            <psc-switch
              formControlName="sunday"
              [checkedLabel]="g('true')"
              [uncheckedLabel]="g('false')"></psc-switch>
          </div>
        </div>
      </div>
    </ng-container>
    <psc-pricing-list
      *ngIf="!blockTariff"
      #pricingListComponent
      [formGroup]="formGroup"
      [upsertPriceErrors]="upsertPriceErrors"></psc-pricing-list>

    <psc-upsert-block-tariff
      *ngIf="blockTariff"
      #blockTariffComponent
      [formGroup]="formGroup"
      [upsertPriceErrors]="upsertPriceErrors">
    </psc-upsert-block-tariff>

    <div class="my-2 text-red-700 h-[24px]">
      <ng-container
        *ngIf="upsertPriceErrors.datesAreNotAYear">
        {{ t('date_not_year') }}
      </ng-container>
    </div>
    <div class="my-2 text-red-700 h-[24px]">
      <ng-container
        *ngIf="upsertPriceErrors.timeslotsAreNotDayError">
        {{ t('timeslots_not_day') }}
      </ng-container>
    </div>

    <div>
      <psc-button
        [label]="t('save_price')"
        (buttonClicked)="savePrice()"
        [disabled]="!formGroup.valid"
        type="primary-blue-2"></psc-button>
      <psc-button
        class="ml-4"
        [routerLink]="this.backRoute"
        [label]="t('cancel')"
        type="secondary-magenta"></psc-button>
    </div>
  </form>

</div>
